// extracted by mini-css-extract-plugin
export default {"navigator":"PublishHistory_navigator__DK9yC","illustration":"PublishHistory_illustration__V11vn"};